/**
 * 회전 관문 (classic-wheel)
 *
 * 이 파일은 tools/derive-classic-maps.mjs 가 만든다. 손으로 고치지 말고 그 스크립트를 고쳐라.
 * 원본: lazygyu/roulette (MIT) 커밋 47230e32242e1c82030eacb4a263420fe95cedb6 의 src/data/maps.ts — "Wheel of fortune"
 * 자세한 출처와 라이선스는 THIRD_PARTY_NOTICES.md 를 보라.
 */

import type { MapDefinition } from '../map/types.ts';

export const classicWheel: MapDefinition = {
  id: "classic-wheel",
  version: 1,
  name: "회전 관문",
  category: 'classic',
  description: "굴곡 통로를 지나 경사 장애물과 교차 회전 막대를 통과하고, 핀 구간을 거쳐 좁은 결승 관문으로 들어간다.",
  highlights: ["굴곡 통로","교차 회전 막대","핀 구간","좁은 결승 관문"],
  origin: {"originalTitle":"Wheel of fortune","note":"원본의 외곽선·구간 순서·회전 방향·결승 병목을 계승했다."},
  bounds: {"x":0,"y":-20,"w":26,"h":140},
  preview: {"x":0,"y":-8,"w":26,"h":124},
  spawn: {"area":{"x":9.7,"y":-8,"w":6.35,"h":10},"perRow":10,"gap":0.62},
  finish: { area: {"x":0,"y":111,"w":26,"h":6} },
  checkpoints: [{"id":"cp1","name":"굴곡 통로","area":{"x":0,"y":22,"w":26,"h":2}},{"id":"cp2","name":"경사 장애물","area":{"x":0,"y":40,"w":26,"h":2}},{"id":"cp3","name":"교차 회전 막대","area":{"x":0,"y":56,"w":26,"h":2}},{"id":"cp4","name":"핀 구간","area":{"x":0,"y":80,"w":26,"h":2}},{"id":"cp5","name":"결승 관문","area":{"x":0,"y":104,"w":26,"h":2}}],
  estimatedDurationSec: [11,53],
  timeLimitSec: 150,
  progressPath: [
    [12.875,-18],
    [12.875,-5.375],
    [9.375,14.25],
    [5.75,20.875],
    [9.75,26],
    [13.625,31.75],
    [16.875,36],
    [10.125,43.25],
    [10.125,54.625],
    [16.125,59],
    [16.125,63],
    [16.125,64],
    [16.125,65],
    [16.125,99.875],
    [15.55,106.75],
    [15.55,111.75],
    [15.55,113],
  ],
  obstacles: [
    {"t":"wall","points":[[16.5,-20],[9.25,-20],[9.25,8.5],[2,19.25],[2,26],[9.75,30],[9.75,33.5],[1.25,41],[1.25,53.75],[8.25,58.75],[8.25,63],[9.25,64],[8.25,65],[8.25,99.25],[15.1,106.75],[15.1,111.75]],"style":"wall"},
    {"t":"wall","points":[[16.5,-20],[16.5,9.25],[9.5,20],[9.5,22.5],[17.5,26],[17.5,33.5],[24,38.5],[19,45.5],[19,55.5],[24,59.25],[24,63],[23,64],[24,65],[24,100.5],[16,106.75],[16,111.75]],"style":"wall"},
    {"t":"wall","points":[[12.75,37.5],[7,43.5],[7,49.75],[12.75,53.75],[12.75,37.5]],"style":"wall"},
    {"t":"wall","points":[[14.75,37.5],[14.75,43],[17.5,40.25],[14.75,37.5]],"style":"wall"},
    {"t":"box","x":15.5,"y":30,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":1},
    {"t":"box","x":15.5,"y":32,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":15.5,"y":28,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":12.5,"y":30,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":12.5,"y":32,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":12.5,"y":28,"hw":0.2,"hh":0.2,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":9.4,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":11.3,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":13.2,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":15.1,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":17,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":18.9,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":20.7,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":22.7,"y":66.6,"hw":0.6,"hh":0.1,"angle":1.018,"style":"box","restitution":0},
    {"t":"box","x":9.4,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":11.3,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":13.2,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":15.1,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":17,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":18.9,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":20.7,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":22.7,"y":69.1,"hw":0.6,"hh":0.1,"angle":-1.018,"style":"box","restitution":0},
    {"t":"box","x":9.5,"y":92,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":12.75,"y":92,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":16,"y":92,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":19.25,"y":92,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":22.5,"y":92,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":11,"y":95,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":14.25,"y":95,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":17.5,"y":95,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":20.75,"y":95,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":9.5,"y":98,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":12.75,"y":98,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":16,"y":98,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":19.25,"y":98,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":22.5,"y":98,"hw":0.25,"hh":0.25,"angle":0.785,"style":"box","restitution":0},
  ],
  devices: [
    {"t":"spinner","x":8,"y":75,"hw":2,"hh":0.1,"omega":3.5,"angle":0,"style":"spinner"},
    {"t":"spinner","x":12,"y":75,"hw":2,"hh":0.1,"omega":-3.5,"angle":0,"style":"spinner"},
    {"t":"spinner","x":16,"y":75,"hw":2,"hh":0.1,"omega":3.5,"angle":0,"style":"spinner"},
    {"t":"spinner","x":20,"y":75,"hw":2,"hh":0.1,"omega":-3.5,"angle":0,"style":"spinner"},
    {"t":"spinner","x":24,"y":75,"hw":2,"hh":0.1,"omega":3.5,"angle":0,"style":"spinner"},
    {"t":"spinner","x":14,"y":106.75,"hw":2,"hh":0.1,"omega":-1.2,"angle":0,"style":"spinner"},
  ],
};
